if (!customElements.get('product-price')) {
  class ProductPrice extends HTMLElement {
    constructor() {
      super();

      this.handleUpdate = this.handleUpdate.bind(this);
    }

    handleReplace(amount) {
      this.innerText = `${window.priceFormat.replace('{{amount}}', amount)}`;
    }

    handleUpdateSinglePrice(event) {
      this.handleReplace(event.detail.price);
    }

    handleUpdate(event) {
      if (!event.detail.price) return;

      if (this.getAttribute('js-type') == 'single') {
        return this.handleUpdateSinglePrice(event);
      }

      const total = event.detail.price * event.detail.quantity;
      const decimalPlaces = (event.detail.price.toString().split('.')[1] || '')
        .length;
      this.handleReplace(total.toFixed(decimalPlaces));
    }

    disconnectedCallback() {
      document.removeEventListener('update:price', this.handleUpdate);
    }

    connectedCallback() {
      document.addEventListener('update:price', this.handleUpdate);
    }
  }

  customElements.define('product-price', ProductPrice);
}
